import { useEffect, useState, Component } from 'react';
import '../../../scss/backoffice.scss';
import { Sidemenu } from '../Sidemenu';
import { Topbar } from '../Topbar';
import { Footer } from '../Footers';
import Moment from 'moment';
import { InputGroup, Form, Alert, Table, Modal, Button } from 'react-bootstrap';
import Swal from 'sweetalert2';
//import { uniform_survey_schedulers } from "../../../model/datatype";
import moment from 'moment-timezone';
import ProgressBar from 'react-bootstrap/ProgressBar';
import ReactTooltip from 'react-tooltip';
import {
  GetUniformSchedules,
  GetUpdateUniformSchedules,
} from '../../../services/ApiUniformSurveyBackoffice';
import { ToastContainer, toast } from 'react-toastify';

export const UniformSchedule = (props: any) => {
  const timezoneStr = 'Asia/Bangkok';

  const formatDateTimeLocal = (date?: string) => {
    if (!date) {
      return '';
    }
    const hasTimezone = date.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(date);
    const utcDate = hasTimezone ? date : date + 'Z';
    return moment(utcDate).tz(timezoneStr).format('yyyy-MM-DDTHH:mm');
  };

  const mapScheduleToFormInput = (schedule: any, fallback?: any) => ({
    id: schedule.id ?? fallback?.id ?? 0,
    startDate:
      formatDateTimeLocal(schedule.startDate ?? schedule.startDateStr) ||
      fallback?.startDate ||
      '',
    endDate:
      formatDateTimeLocal(schedule.endDate ?? schedule.endDateStr) ||
      fallback?.endDate ||
      '',
    isViewOnly:
      typeof schedule.isViewOnly === 'boolean'
        ? schedule.isViewOnly
        : fallback?.isViewOnly ?? false,
  });
  const [formInput, setFormInput] = useState({
    id: 0,
    startDate: '',
    endDate: '',
    isViewOnly: false,
  });
  const [data, seData] = useState({ modifiedDateTime: '' });
  const [lastUpdate, setLastUpdate] = useState(Date);
  const [statusSubmit, setStatusSubmit] = useState(false);
  const [displayFullScreenLoading, setDisplayFullScreenLoading] =
    useState(false);
  const [isLoading, setLoading] = useState(false);
  const query = {
    year: 2023,
    month: 2,
    startDate: '2023-02-16T08:16:43.492Z',
    endDate: '2023-02-18T08:16:43.492Z',
    description: 'xxx',
  };
  useEffect(() => {
    setDisplayFullScreenLoading(true);
    GetUniformSchedules()
      .then((response) => {
        const getData: any = response;
        const dateLast = new Date(getData.modifiedDateTime);
        setLastUpdate(Moment(dateLast).format('DD/MM/YYYY HH:mm:ss'));
        seData(getData);
        setFormInput((oldValues: any) =>
          mapScheduleToFormInput(response, oldValues),
        );
        setDisplayFullScreenLoading(false);
      })
      .catch((error: any) => {
        // Silent fail
      });
  }, []);

  const setInputValue = (e: any) => {
    const { name, type, checked, value } = e.target;
    setFormInput((oldValues: any) => ({
      ...oldValues,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const onSubmit = () => {
    setLoading(true);

    GetUpdateUniformSchedules(formInput)
      .then((response) => {
        setLoading(false);
        Swal.fire({
          icon: 'success',
          title: 'Schedulers',
          text: 'Update successfully',
        });

        // toast.success('Update successfully.', {
        //   position: 'top-right',
        //   autoClose: 3500,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        // });
        // setStatusSubmit(true)
        const getData: any = response;
        const dateLast = new Date(getData.modifiedDateTime);
        setLastUpdate(Moment(dateLast).format('DD/MM/YYYY HH:mm:ss'));
        // Do NOT re-map formInput from save response — backend returns Bangkok time
        // without timezone indicator which conflicts with GET (UTC without Z).
        // formInput already has the correct Bangkok time the user just entered.
        //    setFormInput(
        //         {
        //             id:response.id,
        //             year:response.year,
        //             month:response.month,
        //             startDate: response.startDate,
        //             endDate: response.endDate,
        //             description: response.description,
        //             startDateStr: moment(response.startDate).tz(timezoneStr).format('L'),
        //             endDateStr: moment(response.endDate).tz(timezoneStr).format('L'),
        //         }
        //    )
      })
      .catch((error: any) => {
        setLoading(false);
        return Swal.fire({
          icon: 'warning',
          title: 'Validation',
          text: 'End date must more or equal than Start date.',
        });
      });
  };

  const convertDateServerToTimeZome = (date: string) => {
    if (date !== '') {
      return moment(date + 'Z')
        .tz(timezoneStr)
        .format('yyyy-MM-DDTHH:mm');
    } else {
      return '';
    }
  };
  return (
    <>
      <div className="container-fiuld master-layout">
        <Sidemenu />
        <div className="main-container">
          <div className="col-12 mb-4">
            <Topbar />
          </div>
          <div className="container-fuild">
            <div className="row mb-2">
              <div className="col-12 my-3">
                <h1 className="page-title">Uniform Survey Schedulers</h1>
              </div>
              <div className="col-12 col-sm-12 col-md-12">
                <div className="block-shadow px-5">
                  <div className="row">
                    <div className="col-12 mb-4">
                      <div className="col-12 text-end pb-3 last-updated">
                        Last update : {lastUpdate}
                      </div>
                      {/* { (statusSubmit) ?

                                        <div className="col-12 text-center pb-3"><Alert key="success" variant="success">Update Schedulers successfully.</Alert></div>
                                            :<></>
                                        } */}

                      <div className="form-group">
                        <label className="mb-2">Start Date</label>
                        <input
                          type="datetime-local"
                          value={formInput?.startDate}
                          className="form-control"
                          id="start_date"
                          aria-describedby="Start Date"
                          placeholder=""
                          name="startDate"
                          onChange={setInputValue}
                        />
                      </div>
                    </div>
                    <div className="col-12 mb-4">
                      <div className="form-group">
                        <label className="mb-2">End Date</label>
                        <input
                          type="datetime-local"
                          value={formInput?.endDate}
                          className="form-control"
                          id="end_date"
                          aria-describedby="End Date"
                          placeholder=""
                          name="endDate"
                          onChange={setInputValue}
                        />
                      </div>
                    </div>
                    <div className="col-12 mb-4">
                      <div className="form-group">
                        <Form.Check
                          type="switch"
                          id="is_view_only"
                          name="isViewOnly"
                          label="View only mode"
                          checked={formInput.isViewOnly}
                          onChange={setInputValue}
                        />
                        <div className="form-text">
                          When enabled, users can view the survey but cannot submit changes.
                        </div>
                        <Alert
                          className="mt-3 mb-0"
                          variant={formInput.isViewOnly ? 'warning' : 'success'}
                        >
                          Current mode:{' '}
                          {formInput.isViewOnly
                            ? 'View only - submissions disabled'
                            : 'Submission enabled'}
                        </Alert>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 text-end">
                      <Button
                        onClick={() => onSubmit()}
                        className="btn-submit"
                        disabled={isLoading}
                      >
                        {isLoading ? 'Loading…' : 'Update'}
                      </Button>
                    </div>
                    {/* <div className="col-6 text-start">
                                             
                                             <Button  className="btn-cancel">Cancel</Button>
                                        </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <Footer />
          </div>
        </div>
      </div>
      {displayFullScreenLoading ? (
        <div className="pageLoder">
          <div className="loader-box">
            <div className="spinner"></div>
          </div>
        </div>
      ) : (
        <></>
      )}
      <ToastContainer />
    </>
  );
};
